    class ComponentProductsScroll extends Theme.Component {
  constructor() {
    super();

    this.defineElements({
      section: '.products-scroll',
      footer: '.products-scroll-footer',
      header: '.products-scroll-header',
      images: '.scroll-images',
      imageEls: '.scroll-image',
      benefits: '.benefit',
      benefitEls: '.benefit'
    });

    this.lastActiveIndex = 0;
  }

  connectedCallback() {
    this.bindEvents();
    this.handleScrollProgress();
  }

  bindEvents() {
    window.addEventListener('scroll', () => requestAnimationFrame(() => this.handleScrollProgress()));
    window.addEventListener('resize', () => requestAnimationFrame(() => this.handleScrollProgress()));
  }

  updateBenefits(index) {
    const benefitElements = this.querySelectorAll('.benefit');

    benefitElements.forEach((el) => {
      const iconEl = el.querySelector('.icon-flip');
      const imgEl = el.querySelector('.benefit-icon');
      const titleEl = el.querySelector('.benefit-title');
      const descEl = el.querySelector('.benefit-description');

      if (!iconEl || !imgEl || !titleEl || !descEl) return;

      iconEl.style.transform = 'rotateY(90deg)';
      titleEl.style.opacity = '0';
      descEl.style.opacity = '0';

      setTimeout(() => {
        const newData = window.benefitData[index];
        if (!newData) return;

        const role = el.getAttribute('data-role');
        const roleIndex = role ? role.split('-')[1] : null;
        const newIconUrl = newData[`icon_${roleIndex}`];

        if (roleIndex && newIconUrl) {
          const newImg = new Image();
          newImg.src = newIconUrl;
          newImg.className = 'benefit-icon';
          imgEl.replaceWith(newImg);

          titleEl.innerHTML = `<strong>${newData[`benefit_${roleIndex}`]}</strong>`;
          descEl.innerHTML = newData[`description_${roleIndex}`];
        }

        iconEl.style.transform = 'rotateY(0deg)';
        titleEl.style.opacity = '1';
        descEl.style.opacity = '1';
      }, 300);
    });
  }

  updateButtonState(index) {

  const button = this.elements.footer.querySelector('a');

  if (index >= 0 && window.benefitData[index]) {

    this.elements.footer.style.display = 'block';

    if (button) {

      const data = window.benefitData[index];

      button.href = data.custom_button_url || data.product_url;

    }

  } else {

    this.elements.footer.style.display = 'none';

  }

}

  handleScrollProgress() {
    const isDesktop = window.innerWidth >= 769;
    const section = this.elements.section;
    if (!section) return;

    const scrollImageEls = section.querySelectorAll(isDesktop ? '.scroll-image' : '.products-scroll-slide');
    const sectionTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;
    const viewportHeight = window.innerHeight;
    const scrollY = window.scrollY || window.pageYOffset;

    const scrollProgress = (scrollY + viewportHeight - sectionTop) / sectionHeight;
    const clampedProgress = Math.min(1, Math.max(0, scrollProgress));
    const adjustedProgress = (clampedProgress * scrollImageEls.length) - 0.5;
    const activeIndex = Math.max(0, Math.floor(adjustedProgress));

    if (activeIndex !== this.lastActiveIndex) {
      if (isDesktop) this.updateBenefits(activeIndex);
      this.updateButtonState(activeIndex);
      this.lastActiveIndex = activeIndex;
    }
  }
}

customElements.define('component-products-scroll', ComponentProductsScroll);